import React from 'react';
import ReactDOM from 'react-dom';
import Slide from '@material-ui/core/Slide';
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux'
import store from './redux/store'
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const styles = {
  success: { backgroundColor: '#37FED9', fontSize: '20px' },
  error: { fontSize: '20px' },
  warning: { fontSize: '20px' },
  info: { fontSize: '20px' },
};

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      TransitionComponent={Slide}
      classes={{
        variantSuccess: styles.success,
        variantError: styles.error,
        variantWarning: styles.warning,
        variantInfo: styles.info,
      }}
    >

      <App />

    </SnackbarProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
